import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: 60px 1fr 40px;
	gap: 20px;
	padding: 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	width: 380px;
`;

const StyledImageContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 60px;
	height: 60px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);

	img {
		user-select: none;
		pointer-events: none;
	}
`;

const StyledInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding-top: 7px;
`;

const StyledName = styled(Text)`
	font-weight: 500;
	font-size: 16px;
	line-height: 18px;
	color: #ffffff;
`;

const StyledCount = styled(Text)`
	font-weight: 400;
	font-size: 16px;
	color: #ffffff;
	opacity: 0.5;
`;

const StyledNameContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledPriceContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;

	${Text} {
		font-size: 14px;

		&:first-child {
			color: rgba(255, 255, 255, 0.5);
		}

		&:last-child {
			font-weight: 700;
			color: #ffffff;
		}
	}
`;

const StyledHint = styled.div`
	display: flex;
	align-items: center;
	height: 40px;
	padding: 0 10px;
	background-color: rgba(255, 255, 255, 0.9);
	border-radius: 10px;
	opacity: 0;
	transition: opacity 0.3s ease;
	pointer-events: none;
	z-index: 10000;

	${Text} {
		font-weight: 400;
		font-size: 14px;
		color: #000000;
		white-space: nowrap;
	}

	&.hint-enter {
		opacity: 0;
	}

	&.hint-enter-active,
	&.hint-enter-done,
	&.hint-exit {
		opacity: 1;
	}

	&.hint-exit-active {
		opacity: 0;
	}
`;

export {
	StyledContainer,
	StyledCount,
	StyledHint,
	StyledImageContainer,
	StyledInfoContainer,
	StyledName,
	StyledNameContainer,
	StyledPriceContainer,
};
